module.exports = "<div>\n  Bạn đã đăng nhập thành công!\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/setting/conversation/zalo/login_redirector/zalo.component.html
// module id = ./src/app/pages/admin/icontact/setting/conversation/zalo/login_redirector/zalo.component.html
// module chunks = main